import request, { AxiosResponse } from "axios";
import { kore_url } from "./index";
import axios from "axios";
import { SettingsObject, SettingsPatchObject } from "context/initialState/Settings";

const requireEntity = (param?: string) => {
  const params = new URLSearchParams(param);
  const entity = params.get("entity");

  if (!entity) {
    throw new Error("entity parameter is required");
  }

  return params;
};

export default {
  getAll: async (token: string, param: string) => {
    requireEntity(param);

    const config = {
      method: "GET",
      url: `${kore_url}/api/v4/settings${param}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };

    return request(config)
      .then((settings: AxiosResponse) => {
        return settings.data.items;
      })
      .catch((settingsError) => {
        throw settingsError;
      });
  },

  getSingle: (param: string, token: string, id?: string) => {
    requireEntity(param);
    let config;
    if (!id) {
      config = {
        method: "GET",
        url: `${kore_url}/api/v4/settings/${param}`,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`
        }
      };
    } else {
      config = {
        method: "GET",
        url: `${kore_url}/api/v4/settings/${id}${param}`,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`
        }
      };
    }

    return request(config)
      .then((settings: AxiosResponse) => {
        return settings;
      })
      .catch((settingsError) => {
        throw settingsError;
      });
  },

  create: (settingsConfig: SettingsObject, token: string) => {
    const config = {
      method: "POST",
      url: `${kore_url}/api/v4/settings`,
      data: settingsConfig,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`
      }
    };

    return request(config)
      .then((settings: AxiosResponse) => {
        return settings;
      })
      .catch((settingsError) => {
        throw settingsError;
      });
  },

  update: (param: string, settingsConfig: SettingsObject, token: string, id?: string) => {
    requireEntity(param);
    let config;
    if(!id) {
      config = {
        method: "PUT",
        url: `${kore_url}/api/v4/settings${param}`,
        data: settingsConfig,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`
        }
      };
    } else {
      config = {
        method: "PUT",
        url: `${kore_url}/api/v4/settings/${id}${param}`,
        data: settingsConfig,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`
        }
      };
    }

    return request(config)
      .then((settings: AxiosResponse) => {
        return settings;
      })
      .catch((settingsError) => {
        throw settingsError;
      });
  },

  patch: (param: string, settingsConfig: SettingsPatchObject, token: string, id?: string) => {
    requireEntity(param);
    let config;
    if(!id) {
      config = {
        method: "PATCH",
        url: `${kore_url}/api/v4/settings${param}`,
        data: settingsConfig,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`
        }
      }
    } else {
      config = {
        method: "PATCH",
        url: `${kore_url}/api/v4/settings/${id}${param}`,
        data: settingsConfig,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`
        }
      };
    }

    return request(config)
      .then((settings: AxiosResponse) => {
        return settings;
      })
      .catch((settingsError) => {
        throw settingsError;
      });
  },

  delete: (param: string, token: string, id?: string) => {
    requireEntity(param);
    let config;
    if(!id) {
      config = {
        method: "DELETE",
        url: `${kore_url}/api/v4/settings${param}`,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`
        }
      };
    } else {
      config = {
        method: "DELETE",
        url: `${kore_url}/api/v4/settings/${id}${param}`,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`
        }
      };
    }

    return request(config)
      .then((settings: AxiosResponse) => {
        return settings;
      })
      .catch((settingsError) => {
        return settingsError;
      });
  }
}